import Select from "react-select";
import { useTranslation } from "react-i18next";
import { LS_TYPE_FILTERS } from "../strings";
import { lsTypeFilterOptions } from "../common-confgs/common-vars";

const LeadServiceTypesFilter = ({
  selectedLsType,
  lsTypeSetter,
  handleOnChange = () => {}
}) => {
  const { t } = useTranslation();
  return (
    <div style={{ width: "250px" }}>
      <Select
        className="w-100"
        options={lsTypeFilterOptions(t)}
        defaultValue={{
          name: t("lsTypeFilters.all"),
          id: LS_TYPE_FILTERS.ALL
        }}
        getOptionValue={(opt) => opt.id}
        getOptionLabel={(opt) => opt.name}
        onChange={(option) => {
          if (selectedLsType !== option.id) {
            lsTypeSetter(option.id);
            handleOnChange(option.id);
          }
        }}
      />
    </div>
  );
};
export default LeadServiceTypesFilter;
